import React from 'react';
import loc_ic from "../assets/location_ic.webp";
import star_ic from "../assets/stars.webp";
import grommet_ic from "../assets/grommet-icons.webp";

const features = [
    {
        icon: grommet_ic,
        title: 'Multiple Project Management',
        color: 'var(--color-primary)',
        description: 'Seamlessly manage all your projects in one place. Our intuitive interface provides a centralized hub where you can efficiently track progress and collaborate effectively.'
    },
    {
        icon: loc_ic,
        title: 'Geo-Tagging of Photos',
        color: 'var(--color-accent)',
        description: 'Our platform allows you to capture and geo-tag new images ensuring precise time and place documentation with ease.'
    },
    {
        icon: star_ic,
        title: 'AI Intergration',
        color: 'var(--color-primary)',
        description: 'Leverage the power of Artificial Intelligence. From intelligent insights to automated workflows, our AI help you make smarter decisions and streamline your workflow.'
    }
];

const WhyChooseUs = () => {
    return (
        <section className="why-section">
            <h2 className="h1-48-600">
                Why <span>ConRa</span> Is The Right Choice For You
            </h2>
            <div className="why-container">
                {features.map((feature, index) => (
                    <div className="why-box" key={index}>
                        <div>
                            <div className="why-icon"
                                style={{ backgroundColor: feature.color }}
                            ><img src={feature.icon} /></div>
                            <h3 className="why-title">{feature.title}</h3>
                        </div>
                        <p className="why-desc">{feature.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default WhyChooseUs;
